import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from 'seagull';
import { useResolveCardVerification } from '~/hooks/invoice/useResolveCardVerification';
import { useLocaleKeys } from '~/i18n';
import StripeElementsProvider from '~/providers/StripeElementsProvider';
import { InvoiceStatusScreen } from '../InvoiceStatusScreen/InvoiceStatusScreen';
const VerificationBranchInner = (param)=>{
    let { testId, statusScreenTestId, invoiceId, stripeUrl, clientSecret, amount, vendorName, viewInvoiceAction, onResolved } = param;
    const { t } = useLocaleKeys();
    const verificationTexts = t.adHocInvoiceApproval.verificationRequired;
    const { resolve, isResolving, errorMsg } = useResolveCardVerification({
        invoiceId,
        stripeUrl,
        clientSecret,
        onResolved,
        fallbackErrorMessage: verificationTexts.resolveError()
    });
    return /*#__PURE__*/ _jsx(Box, {
        testId: testId,
        children: /*#__PURE__*/ _jsx(InvoiceStatusScreen, {
            testId: statusScreenTestId,
            title: verificationTexts.title(),
            subtitle: verificationTexts.subtitle({
                amount: amount.display(),
                vendorName
            }),
            description: errorMsg || verificationTexts.description(),
            hideLottie: true,
            primaryAction: {
                label: verificationTexts.resolvePayment(),
                onClick: resolve,
                loading: isResolving,
                biName: 'ad_hoc_invoice_resolve_payment'
            },
            secondaryAction: viewInvoiceAction
        })
    });
};
export const VerificationBranch = (props)=>/*#__PURE__*/ _jsx(StripeElementsProvider, {
        children: /*#__PURE__*/ _jsx(VerificationBranchInner, _object_spread({}, props))
    });
